import { render, staticRenderFns } from "./MantraAdd.vue?vue&type=template&id=414ff8e0&scoped=true&"
import script from "./MantraAdd.vue?vue&type=script&lang=js&"
export * from "./MantraAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414ff8e0",
  null
  
)

export default component.exports